import * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import { PersonDetailDataFragmentDoc } from '../editor.generated';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type AdministratorQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;

export type AdministratorQuery = {
  __typename?: 'Query';
  person: {
    __typename?: 'Person';
    internalNotes?: string | null;
    enterpriseIds?: Array<any> | null;
    id: any;
    createdAt: any;
    title?: string | null;
    gender?: Types.Gender | null;
    firstName?: string | null;
    lastName?: string | null;
    anonymizedAt?: any | null;
    employments: Array<{
      __typename?: 'Employment';
      id: any;
      description?: string | null;
      companyId: any;
      company: { __typename?: 'Company'; id: any; name: string };
    }>;
    enterprises: Array<{ __typename?: 'Enterprise'; id: any; name: string }>;
    user?:
      | {
          __typename?: 'Administrator';
          roleIds?: Array<any> | null;
          isBot: boolean;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          roles: Array<{ __typename?: 'Role'; id: any; name: Types.RoleType }>;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | {
          __typename?: 'Customer';
          invoiceEmail?: string | null;
          customerNumber?: string | null;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          orders: Array<{
            __typename?: 'Order';
            id: any;
            createdAt: any;
            total: number;
          }>;
          bookings: Array<
            | {
                __typename?: 'CourseModuleBooking';
                kind: Types.BookingKind;
                id: any;
                createdAt: any;
                courseModule: {
                  __typename?: 'CourseModule';
                  id: any;
                  title?: string | null;
                  sku: string;
                  startDate: any;
                  endDate: any;
                  dateUncertain: boolean;
                  withTime: boolean;
                  online: boolean;
                  correspondenceCourse: boolean;
                  location?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  secondaryLocation?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  courseUnit: {
                    __typename?: 'CourseUnit';
                    id: any;
                    course: {
                      __typename?: 'Course';
                      id: any;
                      title: string;
                      verboseTitle?: string | null;
                      abbreviation: string;
                    };
                  };
                };
              }
            | {
                __typename?: 'CourseUnitBooking';
                kind: Types.BookingKind;
                id: any;
                createdAt: any;
                courseUnit: {
                  __typename?: 'CourseUnit';
                  id: any;
                  title?: string | null;
                  sku: string;
                  startDate: any;
                  endDate: any;
                  dateUncertain: boolean;
                  withTime: boolean;
                  online: boolean;
                  correspondenceCourse: boolean;
                  location?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  secondaryLocation?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  course: {
                    __typename?: 'Course';
                    id: any;
                    title: string;
                    verboseTitle?: string | null;
                    abbreviation: string;
                  };
                };
              }
          >;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | {
          __typename?: 'Teacher';
          jobTitle?: string | null;
          subjectArea?: string | null;
          slug?: string | null;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | null;
    contactProperties: Array<{
      __typename?: 'ContactProperty';
      id: any;
      key: Types.ContactPropertyKey;
      value: string;
    }>;
    inquiries: Array<{
      __typename?: 'Inquiry';
      id: any;
      createdAt: any;
      status: Types.InquiryStatus;
      assignee?: {
        __typename?: 'Administrator';
        id: any;
        fullName: string;
      } | null;
    }>;
    address: {
      __typename?: 'Address';
      company?: string | null;
      contactPerson?: string | null;
      streetAndNumber?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      other?: string | null;
    };
    invoiceAddress: {
      __typename?: 'Address';
      company?: string | null;
      contactPerson?: string | null;
      streetAndNumber?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      other?: string | null;
    };
  };
};

export type UpdateAdministratorMutationVariables = Types.Exact<{
  userInput: Types.AdministratorInput;
  personInput: Types.PersonInput;
  id: Types.Scalars['UUID'];
}>;

export type UpdateAdministratorMutation = {
  __typename?: 'Mutation';
  adminEditAdministrator: {
    __typename?: 'Person';
    internalNotes?: string | null;
    enterpriseIds?: Array<any> | null;
    id: any;
    createdAt: any;
    title?: string | null;
    gender?: Types.Gender | null;
    firstName?: string | null;
    lastName?: string | null;
    anonymizedAt?: any | null;
    employments: Array<{
      __typename?: 'Employment';
      id: any;
      description?: string | null;
      companyId: any;
      company: { __typename?: 'Company'; id: any; name: string };
    }>;
    enterprises: Array<{ __typename?: 'Enterprise'; id: any; name: string }>;
    user?:
      | {
          __typename?: 'Administrator';
          roleIds?: Array<any> | null;
          isBot: boolean;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          roles: Array<{ __typename?: 'Role'; id: any; name: Types.RoleType }>;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | {
          __typename?: 'Customer';
          invoiceEmail?: string | null;
          customerNumber?: string | null;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          orders: Array<{
            __typename?: 'Order';
            id: any;
            createdAt: any;
            total: number;
          }>;
          bookings: Array<
            | {
                __typename?: 'CourseModuleBooking';
                kind: Types.BookingKind;
                id: any;
                createdAt: any;
                courseModule: {
                  __typename?: 'CourseModule';
                  id: any;
                  title?: string | null;
                  sku: string;
                  startDate: any;
                  endDate: any;
                  dateUncertain: boolean;
                  withTime: boolean;
                  online: boolean;
                  correspondenceCourse: boolean;
                  location?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  secondaryLocation?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  courseUnit: {
                    __typename?: 'CourseUnit';
                    id: any;
                    course: {
                      __typename?: 'Course';
                      id: any;
                      title: string;
                      verboseTitle?: string | null;
                      abbreviation: string;
                    };
                  };
                };
              }
            | {
                __typename?: 'CourseUnitBooking';
                kind: Types.BookingKind;
                id: any;
                createdAt: any;
                courseUnit: {
                  __typename?: 'CourseUnit';
                  id: any;
                  title?: string | null;
                  sku: string;
                  startDate: any;
                  endDate: any;
                  dateUncertain: boolean;
                  withTime: boolean;
                  online: boolean;
                  correspondenceCourse: boolean;
                  location?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  secondaryLocation?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  course: {
                    __typename?: 'Course';
                    id: any;
                    title: string;
                    verboseTitle?: string | null;
                    abbreviation: string;
                  };
                };
              }
          >;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | {
          __typename?: 'Teacher';
          jobTitle?: string | null;
          subjectArea?: string | null;
          slug?: string | null;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | null;
    contactProperties: Array<{
      __typename?: 'ContactProperty';
      id: any;
      key: Types.ContactPropertyKey;
      value: string;
    }>;
    inquiries: Array<{
      __typename?: 'Inquiry';
      id: any;
      createdAt: any;
      status: Types.InquiryStatus;
      assignee?: {
        __typename?: 'Administrator';
        id: any;
        fullName: string;
      } | null;
    }>;
    address: {
      __typename?: 'Address';
      company?: string | null;
      contactPerson?: string | null;
      streetAndNumber?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      other?: string | null;
    };
    invoiceAddress: {
      __typename?: 'Address';
      company?: string | null;
      contactPerson?: string | null;
      streetAndNumber?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      other?: string | null;
    };
  };
};

export type CreateAdministratorMutationVariables = Types.Exact<{
  userInput: Types.AdministratorInput;
  personInput: Types.PersonInput;
}>;

export type CreateAdministratorMutation = {
  __typename?: 'Mutation';
  adminCreateAdministrator: {
    __typename?: 'Person';
    internalNotes?: string | null;
    enterpriseIds?: Array<any> | null;
    id: any;
    createdAt: any;
    title?: string | null;
    gender?: Types.Gender | null;
    firstName?: string | null;
    lastName?: string | null;
    anonymizedAt?: any | null;
    employments: Array<{
      __typename?: 'Employment';
      id: any;
      description?: string | null;
      companyId: any;
      company: { __typename?: 'Company'; id: any; name: string };
    }>;
    enterprises: Array<{ __typename?: 'Enterprise'; id: any; name: string }>;
    user?:
      | {
          __typename?: 'Administrator';
          roleIds?: Array<any> | null;
          isBot: boolean;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          roles: Array<{ __typename?: 'Role'; id: any; name: Types.RoleType }>;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | {
          __typename?: 'Customer';
          invoiceEmail?: string | null;
          customerNumber?: string | null;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          orders: Array<{
            __typename?: 'Order';
            id: any;
            createdAt: any;
            total: number;
          }>;
          bookings: Array<
            | {
                __typename?: 'CourseModuleBooking';
                kind: Types.BookingKind;
                id: any;
                createdAt: any;
                courseModule: {
                  __typename?: 'CourseModule';
                  id: any;
                  title?: string | null;
                  sku: string;
                  startDate: any;
                  endDate: any;
                  dateUncertain: boolean;
                  withTime: boolean;
                  online: boolean;
                  correspondenceCourse: boolean;
                  location?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  secondaryLocation?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  courseUnit: {
                    __typename?: 'CourseUnit';
                    id: any;
                    course: {
                      __typename?: 'Course';
                      id: any;
                      title: string;
                      verboseTitle?: string | null;
                      abbreviation: string;
                    };
                  };
                };
              }
            | {
                __typename?: 'CourseUnitBooking';
                kind: Types.BookingKind;
                id: any;
                createdAt: any;
                courseUnit: {
                  __typename?: 'CourseUnit';
                  id: any;
                  title?: string | null;
                  sku: string;
                  startDate: any;
                  endDate: any;
                  dateUncertain: boolean;
                  withTime: boolean;
                  online: boolean;
                  correspondenceCourse: boolean;
                  location?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  secondaryLocation?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  course: {
                    __typename?: 'Course';
                    id: any;
                    title: string;
                    verboseTitle?: string | null;
                    abbreviation: string;
                  };
                };
              }
          >;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | {
          __typename?: 'Teacher';
          jobTitle?: string | null;
          subjectArea?: string | null;
          slug?: string | null;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | null;
    contactProperties: Array<{
      __typename?: 'ContactProperty';
      id: any;
      key: Types.ContactPropertyKey;
      value: string;
    }>;
    inquiries: Array<{
      __typename?: 'Inquiry';
      id: any;
      createdAt: any;
      status: Types.InquiryStatus;
      assignee?: {
        __typename?: 'Administrator';
        id: any;
        fullName: string;
      } | null;
    }>;
    address: {
      __typename?: 'Address';
      company?: string | null;
      contactPerson?: string | null;
      streetAndNumber?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      other?: string | null;
    };
    invoiceAddress: {
      __typename?: 'Address';
      company?: string | null;
      contactPerson?: string | null;
      streetAndNumber?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      other?: string | null;
    };
  };
};

export type UpdateAdministratorFilesMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
  input: Types.UpdateUserFilesInput;
}>;

export type UpdateAdministratorFilesMutation = {
  __typename?: 'Mutation';
  adminUpdateUserFiles: boolean;
};

export const AdministratorDocument = gql`
  query administrator($id: UUID!) {
    person(id: $id) {
      ...PersonDetailData
    }
  }
  ${PersonDetailDataFragmentDoc}
`;
export type AdministratorComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    AdministratorQuery,
    AdministratorQueryVariables
  >,
  'query'
> &
  (
    | { variables: AdministratorQueryVariables; skip?: boolean }
    | { skip: boolean }
  );

export const AdministratorComponent = (props: AdministratorComponentProps) => (
  <ApolloReactComponents.Query<AdministratorQuery, AdministratorQueryVariables>
    query={AdministratorDocument}
    {...props}
  />
);

/**
 * __useAdministratorQuery__
 *
 * To run a query within a React component, call `useAdministratorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdministratorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdministratorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdministratorQuery(
  baseOptions: Apollo.QueryHookOptions<
    AdministratorQuery,
    AdministratorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<AdministratorQuery, AdministratorQueryVariables>(
    AdministratorDocument,
    options,
  );
}
export function useAdministratorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AdministratorQuery,
    AdministratorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<AdministratorQuery, AdministratorQueryVariables>(
    AdministratorDocument,
    options,
  );
}
export type AdministratorQueryHookResult = ReturnType<
  typeof useAdministratorQuery
>;
export type AdministratorLazyQueryHookResult = ReturnType<
  typeof useAdministratorLazyQuery
>;
export type AdministratorQueryResult = Apollo.QueryResult<
  AdministratorQuery,
  AdministratorQueryVariables
>;
export const UpdateAdministratorDocument = gql`
  mutation updateAdministrator(
    $userInput: AdministratorInput!
    $personInput: PersonInput!
    $id: UUID!
  ) {
    adminEditAdministrator(
      userInput: $userInput
      personInput: $personInput
      id: $id
    ) {
      ...PersonDetailData
    }
  }
  ${PersonDetailDataFragmentDoc}
`;
export type UpdateAdministratorMutationFn = Apollo.MutationFunction<
  UpdateAdministratorMutation,
  UpdateAdministratorMutationVariables
>;
export type UpdateAdministratorComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateAdministratorMutation,
    UpdateAdministratorMutationVariables
  >,
  'mutation'
>;

export const UpdateAdministratorComponent = (
  props: UpdateAdministratorComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    UpdateAdministratorMutation,
    UpdateAdministratorMutationVariables
  >
    mutation={UpdateAdministratorDocument}
    {...props}
  />
);

/**
 * __useUpdateAdministratorMutation__
 *
 * To run a mutation, you first call `useUpdateAdministratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdministratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdministratorMutation, { data, loading, error }] = useUpdateAdministratorMutation({
 *   variables: {
 *      userInput: // value for 'userInput'
 *      personInput: // value for 'personInput'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateAdministratorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAdministratorMutation,
    UpdateAdministratorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAdministratorMutation,
    UpdateAdministratorMutationVariables
  >(UpdateAdministratorDocument, options);
}
export type UpdateAdministratorMutationHookResult = ReturnType<
  typeof useUpdateAdministratorMutation
>;
export type UpdateAdministratorMutationResult =
  Apollo.MutationResult<UpdateAdministratorMutation>;
export type UpdateAdministratorMutationOptions = Apollo.BaseMutationOptions<
  UpdateAdministratorMutation,
  UpdateAdministratorMutationVariables
>;
export const CreateAdministratorDocument = gql`
  mutation createAdministrator(
    $userInput: AdministratorInput!
    $personInput: PersonInput!
  ) {
    adminCreateAdministrator(userInput: $userInput, personInput: $personInput) {
      ...PersonDetailData
    }
  }
  ${PersonDetailDataFragmentDoc}
`;
export type CreateAdministratorMutationFn = Apollo.MutationFunction<
  CreateAdministratorMutation,
  CreateAdministratorMutationVariables
>;
export type CreateAdministratorComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateAdministratorMutation,
    CreateAdministratorMutationVariables
  >,
  'mutation'
>;

export const CreateAdministratorComponent = (
  props: CreateAdministratorComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    CreateAdministratorMutation,
    CreateAdministratorMutationVariables
  >
    mutation={CreateAdministratorDocument}
    {...props}
  />
);

/**
 * __useCreateAdministratorMutation__
 *
 * To run a mutation, you first call `useCreateAdministratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdministratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdministratorMutation, { data, loading, error }] = useCreateAdministratorMutation({
 *   variables: {
 *      userInput: // value for 'userInput'
 *      personInput: // value for 'personInput'
 *   },
 * });
 */
export function useCreateAdministratorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateAdministratorMutation,
    CreateAdministratorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateAdministratorMutation,
    CreateAdministratorMutationVariables
  >(CreateAdministratorDocument, options);
}
export type CreateAdministratorMutationHookResult = ReturnType<
  typeof useCreateAdministratorMutation
>;
export type CreateAdministratorMutationResult =
  Apollo.MutationResult<CreateAdministratorMutation>;
export type CreateAdministratorMutationOptions = Apollo.BaseMutationOptions<
  CreateAdministratorMutation,
  CreateAdministratorMutationVariables
>;
export const UpdateAdministratorFilesDocument = gql`
  mutation updateAdministratorFiles($id: UUID!, $input: UpdateUserFilesInput!) {
    adminUpdateUserFiles(id: $id, input: $input)
  }
`;
export type UpdateAdministratorFilesMutationFn = Apollo.MutationFunction<
  UpdateAdministratorFilesMutation,
  UpdateAdministratorFilesMutationVariables
>;
export type UpdateAdministratorFilesComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateAdministratorFilesMutation,
    UpdateAdministratorFilesMutationVariables
  >,
  'mutation'
>;

export const UpdateAdministratorFilesComponent = (
  props: UpdateAdministratorFilesComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    UpdateAdministratorFilesMutation,
    UpdateAdministratorFilesMutationVariables
  >
    mutation={UpdateAdministratorFilesDocument}
    {...props}
  />
);

/**
 * __useUpdateAdministratorFilesMutation__
 *
 * To run a mutation, you first call `useUpdateAdministratorFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdministratorFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdministratorFilesMutation, { data, loading, error }] = useUpdateAdministratorFilesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdministratorFilesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAdministratorFilesMutation,
    UpdateAdministratorFilesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAdministratorFilesMutation,
    UpdateAdministratorFilesMutationVariables
  >(UpdateAdministratorFilesDocument, options);
}
export type UpdateAdministratorFilesMutationHookResult = ReturnType<
  typeof useUpdateAdministratorFilesMutation
>;
export type UpdateAdministratorFilesMutationResult =
  Apollo.MutationResult<UpdateAdministratorFilesMutation>;
export type UpdateAdministratorFilesMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateAdministratorFilesMutation,
    UpdateAdministratorFilesMutationVariables
  >;
